import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.kissseller').service('KissSellerSvc', KissSellerSvc);

    KissSellerSvc.$inject = ['$sessionStorage', 'SellersDA'];

    /* @ngInject */
    function KissSellerSvc($sessionStorage, SellersDA) {
        var exports = {
            searchSellers: searchSellers,
            searchFiltredSellers: searchFiltredSellers,
            getSeller: getSeller,
            searchRelations: searchRelations,
            enableMyInvoice: enableMyInvoice,
            disableMyInvoice: disableMyInvoice,
            canEnableMyInvoice: canEnableMyInvoice,
            getSellerListFilter: getSellerListFilter,
            initSessionStorage: initSessionStorage,
            getDiscardedIdentifiers: getDiscardedIdentifiers,
            deleteDiscardedIdentifier: deleteDiscardedIdentifier,
            getSubEntities: getSubEntities,
            getDivisions: getDivisions,
            getBillingWarrants: getBillingWarrants,
            getSubEntityRelations: getSubEntityRelations,
            searchRelatedSubEntities: searchRelatedSubEntities,
            searchRelatedLegalEntities: searchRelatedLegalEntities,
            getSubEntity: getSubEntity,
        };

        return exports;

        /**
         * Recherche des fournisseurs
         */
        function searchSellers(value) {
            $sessionStorage.sellerListFilter = value;
            return SellersDA.searchSellers(value);
        }

        function searchFiltredSellers(sellersFilter) {
            $sessionStorage.sellerListFilter = sellersFilter;
            // Supprime les 'ALL' pour le status (clone le filtre pour ne pas l'impacter)
            var filter = sellersFilter.preparBeforeSearch();
            return SellersDA.searchFiltredSellers(filter);
        }

        function getSellerListFilter() {
            return $sessionStorage.sellerListFilter;
        }

        function getSeller(sellerId) {
            return SellersDA.getSeller(sellerId);
        }

        function searchRelations(id, sellerRelationFilter) {
            var filter = sellerRelationFilter.preparBeforeSearch();
            return SellersDA.searchRelations(id, filter);
        }

        function enableMyInvoice(sellerId, principalId) {
            return SellersDA.enableMyInvoice(sellerId, principalId);
        }

        function disableMyInvoice(sellerId, principalId) {
            return SellersDA.disableMyInvoice(sellerId, principalId);
        }

        function canEnableMyInvoice(sellerId, principalId) {
            return SellersDA.canEnableMyInvoice(sellerId, principalId);
        }

        function initSessionStorage() {
            $sessionStorage.sellerListFilter = null;
        }

        /**
         * Récupération de la liste des identifiants rejetés par le fournisseur.
         */
        function getDiscardedIdentifiers(sellerId) {
            return SellersDA.getDiscardedIdentifiers(sellerId);
        }

        /**
         * Suppression d'un identifiant fiscal rejeté par le fournisseur.
         */
        function deleteDiscardedIdentifier(sellerId, discardedIdentifierId) {
            return SellersDA.deleteDiscardedIdentifier(sellerId, discardedIdentifierId);
        }

        /**
         * Récupération des établissements.
         */
        function getSubEntities(legalEntityId) {
            return SellersDA.getSubEntities(legalEntityId);
        }

        /**
         * Récupération des divisions.
         */
        function getDivisions(legalEntityId) {
            return SellersDA.getDivisions(legalEntityId);
        }

        /**
         * Récupération les relations d'un établissement.
         */
        function getSubEntityRelations(subEntityId, invBuyerSubEntityRelationFilter) {
            const filter = invBuyerSubEntityRelationFilter.preparBeforeSearch();
            return SellersDA.getSubEntityRelations(subEntityId, filter);
        }

        function searchRelatedSubEntities(searchValue, subEntityId) {
            return SellersDA.searchRelatedSubEntities(searchValue, subEntityId);
        }

        function searchRelatedLegalEntities(searchValue, subEntityId) {
            return SellersDA.searchRelatedLegalEntities(searchValue, subEntityId);
        }

        /**
         * Récupération des mandats de facturation.
         */
        function getBillingWarrants(sellerId) {
            return SellersDA.getBillingWarrants(sellerId);
        }

        function getSubEntity(subEntityId) {
            return SellersDA.getSubEntity(subEntityId);
        }
    }
})();
